import React from 'react';
import PropTypes from 'prop-types';
import capitalize from '../../../stringUtils';
import './ProjectDetail.scss';

const renderWorkLocation = (workLocation, shortOfficeLocation) => {
  if (workLocation === 'remote') {
    return (
      <div className="commitment work-location">
        <p>
          <i className="fas fa-map-marker-alt" />
          Remote
        </p>
      </div>
    );
  } if (workLocation === 'office' || workLocation === 'both') {
    return (
      <div className="commitment work-location">
        <p>
          <i className="fas fa-map-marker-alt" />
          Office
          { shortOfficeLocation
          && (
          <span>
            {' '}
            (
            <strong>{shortOfficeLocation}</strong>
            )
          </span>
          )}
          { workLocation === 'both' && ' and Remote'}
        </p>
      </div>
    );
  } if (workLocation === 'hybrid') {
    return (
      <div className="commitment work-location">
        <p>
          <i className="fas fa-map-marker-alt" />
          Hybrid
        </p>
      </div>
    );
  }
  return null;
};

function ProjectDetail(props) {
  const {
    className,
    name,
    workCommitment,
    tags,
    duration,
    workLocation,
    projectInvitationStatus,
    levels,
    employmentType,
    showProjectEmploymentType,
  } = props;
  return (
    <div className={`project-detail ${className}`}>
      {showProjectEmploymentType && (
      <span className={`${employmentType}`}>
        {capitalize(employmentType)}
        {' '}
        Position
      </span>
      ) }
      <h3 className="mb-2">
        {name}
        {projectInvitationStatus
          && (
          <span className="badge small invited-badge">
            {projectInvitationStatus}
          </span>
          )}
      </h3>
      <div className="g-row g-row--wrap logistics mb-2 body-text-2 card-icons">
        {duration && employmentType !== 'full_time'
          && (
          <div className="commitment duration">
            <i className="fas fa-calendar-day" />
            {' '}
            {`${duration} month duration`}
          </div>
          )}
        {employmentType === 'consulting'
          && (
          <div className="commitment work-commitment">
            <i className="fas fa-clock" />
            {`${workCommitment} hrs/week`}
          </div>
          )}
        {renderWorkLocation(workLocation)}
        {levels
        && (
        <div className="commitment work-commitment">
          <i className="fa fa-certificate" />
          {`${levels}`}
        </div>
        )}
      </div>
      <div className="tags mb-3">
        {tags.map((t) => (
          <span key={t} className="badge small normal-font me-2">{t}</span>
        ))}
      </div>
    </div>
  );
}

ProjectDetail.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  workCommitment: PropTypes.number.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  duration: PropTypes.string.isRequired,
  workLocation: PropTypes.string.isRequired,
  projectInvitationStatus: PropTypes.string,
  levels: PropTypes.string,
  employmentType: PropTypes.string,
  showProjectEmploymentType: PropTypes.bool,
};

ProjectDetail.defaultProps = {
  className: '',
  projectInvitationStatus: '',
  employmentType: '',
  showProjectEmploymentType: false,
  levels: '',
};

export default ProjectDetail;
